import { Layers } from "appworks/graphics/layers/layers";
import { SpineContainer } from "appworks/graphics/pixi/spine-container";
import { SpineService } from "appworks/graphics/spine/spine-service";
import { Services } from "appworks/services/services";
import { Point } from "appworks/utils/geom/point";
import { gameLayers } from "game-layers";
import Matter = require("matter-js");
import { FowlAbstractObstacleSubcomponent } from "./fowl-abstract-obstacle-subcomponent";
import { Contract } from "appworks/utils/contracts/contract";
import { SoundService } from "appworks/services/sound/sound-service";

export class FowlPigSubcomponent extends FowlAbstractObstacleSubcomponent {
    public triggered: boolean = false;

    protected spine: SpineContainer;

    constructor(public position: Point, public layer: Layers = gameLayers.FlingBonus) {
        super(position, layer);

        this.spine = Services.get(SpineService).createSpineContainer("faf_pig", this.layer.getPosition("pig"));
        this.spine.setSpineAnchor({ x: 0.5, y: 1 });
        this.spine.play("idle");
        this.layer.add(this.spine);

        this.spine.landscape.setPosition(position);
        this.spine.portrait.setPosition(position);
    }

    public onCollision(foxBody: Matter.Body) {
        super.onCollision(foxBody);

        // setting velocity directly as it's more consistent and cartoony
        Matter.Body.setVelocity(foxBody, {
            x: Math.max(7, foxBody.velocity.x * 1.25),
            y: -30,
        });
        Matter.Body.setAngularVelocity(foxBody, Math.max(0.3, foxBody.angularVelocity * 1.25));
    }

    public animate(): Contract<void> {
        Services.get(SoundService).customEvent("faf_hit_pig");
        return super.animate();
    }
}
